import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useSession } from "@/context/SessionContext";
import JimTerminal from "@/components/dashboard/JimTerminal";
import Gateway from "@/components/gateway/Gateway";

// Standalone PWA launcher view (/jim-companion). Mounts JIM directly as the
// root, gated behind the persistent auth handshake (localStorage token boot).
export default function JimCompanion() {
  const { authed } = useSession();
  const navigate = useNavigate();

  if (authed === null) {
    return (
      <div className="h-full w-full grid place-items-center bg-cream" data-testid="jim-companion-boot">
        <Loader2 size={30} className="text-gold animate-spin" />
      </div>
    );
  }
  if (authed === false) return <Gateway />;

  // isOpen is permanent on this route — closing simply returns to the full app.
  return (
    <div className="h-full" data-testid="jim-companion">
      <JimTerminal onClose={() => navigate("/")} />
    </div>
  );
}
